<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill-rule="evenodd"><path d="M6.628.028a.3.3 0 0 0-.253 0L.407 2.778A.767.767 0 0 0 0 3.486v.642a31.638 31.638 0 0 0 .32 4.521c.105.727.294 1.44.565 2.123l.22.554a7.145 7.145 0 0 0 1.752 2.602 8.278 8.278 0 0 0 2.443 1.59l1.09.457c.075.032.16.032.235 0l1.092-.457a8.259 8.259 0 0 0 2.433-1.59 7.138 7.138 0 0 0 1.75-2.6l.288-.721a8.326 8.326 0 0 0 .476-1.761c.226-1.435.338-2.886.336-4.339v-1.02a.768.768 0 0 0-.406-.709L6.628.028Z" opacity=".45" fill="currentColor"/><path d="M2.5 9.999a5.072 5.072 0 0 1 9.842-1.655c.093-.008.188-.012.284-.012a3.334 3.334 0 1 1 0 6.667H7.564a5.032 5.032 0 0 1-5.063-5Z" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering112',
});
</script>
